<template>
	<v-app>
		<v-container
			justify-ceneter
			align-center
			fluid
			fill-height
			:style="{background: $vuetify.theme.themes['dark'].background}"
		>
			<!-- 登入視窗 -->
			<v-row align="center" justify="center">
				<v-col cols="12" sm="8" md="6" lg="4">
					<router-view></router-view>
				</v-col>
			</v-row>	
		</v-container>
	</v-app>
</template>
<script>

	export default {
		name: 'SignIn',
		components: {
		},
		created: function() {

		},
		mounted: function() {
			console.log(process.env.VUE_APP_MODE)
			console.log(process.env.VUE_APP_API_ENDPOINT)
		},
		data: function() {
			return {
				// 登入視窗標題
				form_title: '',

				// 登入視窗副標題
				form_subtitle: '',

				// 帳號的數值
				account: '',

				// 帳號輸入框的標題文字
				account_label_text: '', 

				// 密碼的數值
				password: '',

				// 密碼輸入框的標題文字
				password_label_text: '',

				// 登入按鈕的文字
				form_action_btn_text: '',

				// 登入如果失敗的提示訊息框文字
				feed_back_text: '',

				// 提示訊息框文字是否顯示
				is_show: false,

				// 提示訊息框文字關閉文字
				close_text: '',

				// 提示訊息框文字多久會自動消失
				timeout: 0,			
			}
		},
		methods: {
            /**
             * 2022/1/2 created by Watson
             *
             * function description:
             * 初始化頁面參數
             *
             * @return {none}
            */			
			initPage: function() {
				this.form_title           = 'Optimize99'
				this.form_subtitle        = '管理後台'
				this.account              = ''
				this.account_label_text   = '信箱'
				this.password             = ''
				this.password_label_text  = '密碼'
				this.form_action_btn_text = '登入'
				this.feed_back_text       = ''
				this.is_show              = false
				this.close_text           = '關閉'
				this.timeout              = 1000
			},			
            /**
             * 2022/1/2 created by Watson
             *
             * function description:
             * 登入功能
             *
             * @return {none}
            */ 			
			signIn: async function() {
			}
		}
	};
</script>
<style>
	
</style>